'use strict';

var chunkV6YUYBTJ_js = require('./chunk-V6YUYBTJ.js');
var chunkWAUX3N2G_js = require('./chunk-WAUX3N2G.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var jsxRuntime = require('react/jsx-runtime');

var n=({breadCrumbLinks:s,ariaLabel:c,className:r})=>{let i=r||"";return s?.length>1?jsxRuntime.jsx("nav",{className:chunkWAUX3N2G_js.a(`${chunk32OAM7MJ_js.a}-breadcrumbs ${i}`),"aria-label":c,children:jsxRuntime.jsx("ol",{className:"breadcrumbs-list",children:s?.map((e,l)=>l<s?.length-1?jsxRuntime.jsxs("li",{className:"breadcrumbs-list-item",children:[e,jsxRuntime.jsx(chunkV6YUYBTJ_js.b,{name:"chevron_right_black",size:"sm",className:"icon"})]},l):jsxRuntime.jsx("li",{className:"breadcrumbs-list-item",children:e},l))})}):null},b=n;

exports.a = b;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-VITLKPVO.js.map